import $ from "jquery";
//import '../util/resizeTextarea';
import '../util/textarea_resizer';

	//HTML5 video autoplay on mobile fix
	function mobileHeaderVideo() {
		$('video#wp-custom-header-video').attr('playsinline', '');
		$('video#wp-custom-header-video').attr('muted', '');
	}

	//Mobile menu
		//Menu show when scrolling upwards
		function menuShowOnScroll() {
			if( $(window).width() < 1024 ) {
			var didScroll;
			var lastScrollTop = 0;
			var scrollMoreThan = 5;
			var menuHeight = $('.menu-section').outerHeight();
			var screenHeight = $(window).height();

			function hasScrolled() {
				var st = $('html').scrollTop();
				
				// Make sure the page is scrolled more than scrollMoreThan
				if(Math.abs(lastScrollTop - st) <= scrollMoreThan)
					return;
				if (st > lastScrollTop && st > menuHeight){
					// Scroll Down
					$('.menu-section').removeClass('nav-down').addClass('nav-up');
					
				} else if (st + $(window).height() < $(document).height()) {
					// Scroll Up
					$('.menu-section').removeClass('nav-up').addClass('nav-down');
					
				}
				// Only show scroll to top arrow when user has scrolled one screenHeight
				if (st > lastScrollTop && st > screenHeight) {
					$('.to-top').removeClass('no-to-top').addClass('yes-to-top');
				} else if( st < screenHeight ) {
					$('.to-top').removeClass('yes-to-top').addClass('no-to-top');
				}

				lastScrollTop = st;
			}

				$(window).scroll(function(){
					didScroll = true;
					if( $('.mobile').hasClass('open') ) {
						$('.mobile').toggleClass('open');
						$('.burger-icon').toggleClass('open-icon close-icon')
					}
				})
				setInterval(function() {
					if (didScroll) {
						hasScrolled();
						didScroll = false;
					}
				}, 250); 
			}
		}

	//Set width for fixed header background
		var width;
		function featuredMediaWidth () {
			width = $('main.single, main.page').width();
			$('.featured-media').width(width);
		}

	// Single page to-content arrow
		$('a[href*=\\#content]').on('click', function(e){
			e.preventDefault();
			$('html, body').animate({
					scrollTop : $(this.hash).offset().top
			}, 1000);
		});

	// click the to-top arrow
	$('.to-top').on('click', function(e) {
		e.preventDefault();
		$('html, body').animate({ scrollTop: 0 }, 1000);
	})

export default {
	finalize() {

	//FAQ
	$('.toggleShowQ').click(function() {
		var $qna = $(this).parents('.qna');
		var $siblings = $qna.siblings();
		if($siblings.hasClass('open')){
			$('.qna.open').removeClass('open');
		}
		$qna.toggleClass('open');
	})

	$('.af-submit').click(function() {
		$('.acf-field-group[data-name="kontaktinfo"]').css('display', 'block');
		$('.af-submit button').css('pointer-events', 'auto');
	});

	//Mobile menu
		//Open/close menu
		$('.toggleMenu').click(function() {
			$('.mobile').toggleClass('open');
			$('.burger-icon').toggleClass('open-icon close-icon');
		})

		if( $(window).width() < 1024 ) {
			menuShowOnScroll();
		}
		featuredMediaWidth();
		mobileHeaderVideo();

		$('textarea').autogrow();

		$(window).on('resize', function(){
			if( $(window).width() < 1024 ) {
				menuShowOnScroll();
			}
			featuredMediaWidth();
		});

		function homepageTransition() {
			setTimeout(function() {
				$("body").removeClass("preload");
			}, 200);
			setTimeout(function() {
				$("body").addClass("no-transitions");
			}, 5000);
		}
		homepageTransition();
	}
}